export default {
  model (resource) {
    return Object.assign({
      customerId: null,
      opportunityId: null,
      title: '',
      content: ''
    }, resource)
  },
  rules () {
    return {
      title: [
        {required: true, message: 'El título es requerido'},
        {min: 1, max: 255, message: 'El contenido debe ser entre 1 y 255 carácteres'}
      ],
      content: [
        {required: true, message: 'Las anotaciones son requeridas'},
        {min: 1, max: 255, message: 'La anotacion debe ser entre 1 y 255 carácteres'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/notes/notes-model.js